// hooks/useSignalRListener.js
import { useEffect } from "react";
import { useSignalRContext } from "./signalRProvider";

export const useSignalRListener = (eventName, handler) => {
    const { connection, isConnected } = useSignalRContext();

    useEffect(() => {
        if (!isConnected || !connection) return;

        connection.on(eventName, handler);
        return () => {
            connection.off(eventName, handler);
        };
    }, [connection, isConnected, eventName, handler]);
};
